import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardComponent } from './core/dashboard/dashboard.component';
import { CitywireInternalAccountsGuard } from '@tpapa/citywire-internal-accounts-angular';
import { redirectGuard } from './core/guards/redirect.guard';
import { hasRole } from './core/authorization/has-role';
import { USER_ROLES } from './core/constants/cms-user-roles';
import { AccessRestrictedComponent } from './shared/standalone/components/access-restricted/access-restricted.component';
import { NewsletterManagementModule } from './newsletter-management/newsletter-management.module';
import { ContentListManagementModule } from './content-list-management/content-list-management.module';
import { ContentManagementModule } from './content-management/content-management.module';
import { ContentModule } from './content/content.module';
import { ReportingModule } from './reporting/reporting.module';
import { AuthorManagementModule } from './author-management/author-management.module';
import { TopicManagementModule } from './topic-management/topic-management.module';
import { UserSettingsModule } from './user-settings/user-settings.module';
import { ManagerContentModule } from './manager-content/manager-content.module';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [CitywireInternalAccountsGuard],
    children: [
      {
        path: 'newsletter',
        loadChildren: () => NewsletterManagementModule,
        data: { title: 'Newsletter Dashboard' },
      },
      {
        path: 'reporting',
        loadChildren: () => ReportingModule,
      },
      {
        path: 'content-list',
        loadChildren: () => ContentListManagementModule,
        data: { title: 'Shakespeare - Content Lists' },
      },
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
      {
        path: 'admin/authors',
        loadChildren: () => AuthorManagementModule,
        data: { title: 'Shakespeare - Manage Authors' },
      },
      {
        path: 'admin/topics',
        loadChildren: () => TopicManagementModule,
        data: { title: 'Shakespeare - Topic Management' },
        canActivate: [hasRole(USER_ROLES.CanEditTopic)],
      },
      {
        path: 'user-settings',
        loadChildren: () => UserSettingsModule,
        data: { title: 'Shakespeare - User Settings' },
      },
      {
        path: 'dashboard',
        loadChildren: () => ContentManagementModule,
        data: { title: 'Shakespeare - Dashboard' },
      },
      {
        path: 'content',
        loadChildren: () => ContentModule,
        data: { title: 'Shakespeare - Content' },
      },
      {
        path: 'poll',
        canActivate: [redirectGuard(true)],
        component: DashboardComponent,
        children: [
          {
            path: '**',
            canActivate: [redirectGuard(true)],
            component: DashboardComponent,
          },
        ],
      },
      {
        path: 'managers',
        loadChildren: () => ManagerContentModule,
        data: { title: 'Shakespeare - Managers' },
      },
      {
        path: 'access-restricted',
        component: AccessRestrictedComponent,
      },
    ],
  },
  {
    path: '**',
    canLoad: [CitywireInternalAccountsGuard],
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
